import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/sharp-solid-svg-icons'
import { ActionIcon } from '@mantine/core'
import React from 'react'
import type { NavbarElementProps } from 'react-day-picker'

import Icon from '../../Icon'

type CustomNavbarProps = NavbarElementProps

const CustomNavbar = ({
  onPreviousClick,
  onNextClick,
}: CustomNavbarProps): React.ReactElement => {
  return (
    <div
      style={{
        padding: '20px',
        position: 'absolute',
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '1.2em',
      }}
    >
      <div style={{ marginLeft: '-10px' }}>
        <ActionIcon onClick={() => onPreviousClick()} size="lg">
          <FontAwesomeIcon icon={faChevronLeft} />
        </ActionIcon>
      </div>
      <div className="text-muted text-small">
        <Icon
          icon="far fa-lock-alt"
          tooltip={i18n.t(
            `combine_monthly_views`,
            `Monatsansichten zusammenhängend`,
          )}
        />
      </div>
      <div style={{ marginRight: '-10px' }}>
        <ActionIcon onClick={() => onNextClick()} size="lg">
          <FontAwesomeIcon icon={faChevronRight} />
        </ActionIcon>
      </div>
    </div>
  )
}

export default CustomNavbar
